import React from "react";
import BCMSRecord from "../../classes/BCMSRecord";

const ReactContext = React.createContext(null);

export default function BCMSContext(props) {
    const state = props.state ?? {};

    // Controller used by the BCMSContext
    // Defines the state and dispatcher function that updates the model
    const controller = {
        state,

        // dispatcher :: (*, ARRAY) -> VOID
        // Updates the state of the controller to the value passed and
        // updates the context of the passed classes to have the new state
        dispatcher: (type, value, classes) => {
            // The type parameter is to mirror the same dispatch properties as the BCMSController
            // In order to maintain backwards compatiability

            controller.state = value;
            BCMSRecord.globalControllerFor(classes, controller);
        }
    }

    return (
        <ReactContext.Provider value={ controller }>
            { props.children }
        </ReactContext.Provider>
    );
}

// Hook to use the BCMSContext component context
export const useBCMSContext = () => React.useContext(ReactContext);